export const plainDocument = (text = "") => ({
  type: "doc",
  content: text.split("\n").map((line) => ({
    type: "paragraph",
    ...(line ? { content: [{ type: "text", text: line }] } : {}),
  })),
});

// Keep this newline convention identical to backend answer_document.document_text.
export const documentText = (node) => {
  if (node.type === "text") return node.text;
  if (node.type === "hardBreak") return "\n";
  return (node.content || [])
    .map(documentText)
    .join(node.type === "paragraph" ? "" : "\n");
};

export const safeAnswerDocument = (document, text) => {
  try {
    return document && documentText(document) === text
      ? document
      : plainDocument(text);
  } catch {
    return plainDocument(text);
  }
};

export const studentInputSettings = (value) => {
  try {
    return typeof value === "string" ? JSON.parse(value) : value || {};
  } catch {
    return {};
  }
};

// Strip editor-generated attributes (e.g. list start) from our restricted format.
export const cleanDocument = (node) => ({
  type: node.type,
  ...(node.text !== undefined ? { text: node.text } : {}),
  ...(node.marks?.length
    ? { marks: node.marks.map(({ type }) => ({ type })) }
    : {}),
  ...(node.content ? { content: node.content.map(cleanDocument) } : {}),
});

export const formatAnswerSegments = (segments, document, text) => {
  if (!document || documentText(document) !== text) return segments;
  const runs = [];
  let offset = 0;
  const visit = (node, list = null) => {
    if (node.type === "text" || node.type === "hardBreak") {
      const value = documentText(node);
      runs.push({
        start: offset,
        end: offset + value.length,
        marks: node.marks || [],
      });
      offset += value.length;
      return;
    }
    const children = node.content || [];
    children.forEach((child, index) => {
      if (index && node.type !== "paragraph") offset += 1;
      const start = offset;
      const nextList = ["bulletList", "orderedList"].includes(node.type)
        ? {
            marker: node.type === "bulletList" ? "•" : `${index + 1}.`,
            depth: (list?.depth || 0) + 1,
          }
        : list;
      visit(child, nextList);
      if (child.type === "listItem") {
        const first = runs.find((run) => run.start === start);
        if (first) first.list = nextList;
      }
    });
  };
  visit(document);
  return segments.flatMap((segment) => {
    const boundaries = [
      ...new Set([
        segment.start,
        segment.end,
        ...runs
          .flatMap((run) => [run.start, run.end])
          .filter((n) => n > segment.start && n < segment.end),
      ]),
    ].sort((a, b) => a - b);
    return boundaries.slice(0, -1).map((start, index) => {
      const end = boundaries[index + 1];
      const run = runs.find((item) => item.start <= start && item.end > start);
      return {
        ...segment,
        start,
        end,
        text: text.slice(start, end),
        marks: run?.marks || [],
        list: start === run?.start ? run.list : null,
      };
    });
  });
};
